<template>
    
    <div flat bordered class="card board bg-white q-pa-md">
        
        <div class="card-content" style="min-width: 320px">
            <div class="media">
      <div class="media-left">
        
        <svg xmlns="http://www.w3.org/2000/svg" height="3em" viewBox="0 0 640 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M392.8 1.2c-17-4.9-34.7 5-39.6 22l-128 448c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l128-448c4.9-17-5-34.7-22-39.6zm80.6 120.1c-12.5 12.5-12.5 32.8 0 45.3L562.7 256l-89.4 89.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-112-112c-12.5-12.5-32.8-12.5-45.3 0zm-306.7 0c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l112 112c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256l89.4-89.4c12.5-12.5 12.5-32.8 0-45.3z"/></svg>
        
      </div>
      <div class="media-content">
        <p class="title is-4">{{ title }}</p>
        <p class="subtitle is-6" v-html="description"></p>
        
      </div>
      </div>
      
      <!-- <div class="row items-center no-wrap">
        <div class="is-pulled-right">
          <flowy-drag-handle v-if="!required">

            <b-button size="is-small" color="is-success" round flat icon="drag_handle">
                move
            </b-button>
          </flowy-drag-handle>
          <b-button v-if="!required" color="is-primary" size="is-small" class="q-pa-none" no-caps @click="remove()">x</b-button> 
        
        </div>
        <div class="col">
          <div class="text-h6">{{ title }}</div>
        </div>

        
      </div> -->
      <!-- <div class="q-py-md" v-html="description">
      </div> -->
      
      <b-dropdown class="indicator-add" :triggers="['hover']" aria-role="list">
            <template #trigger>
                <span class="indicator-add">
                +
                </span>
            </template>
            <b-dropdown-item disabled><b>Add a step</b></b-dropdown-item>
            <b-dropdown-item @click="" aria-role="listitem">Model</b-dropdown-item>
            <b-dropdown-item @click="" aria-role="listitem">Function</b-dropdown-item>
            <b-dropdown-item @click="" aria-role="listitem">Action</b-dropdown-item>
        </b-dropdown>
    </div>
    
</div>

</template>
<script>
export default {
  data () {
    return {
      text: 'This is component A'
    }
  },
  props: ['remove', 'add', 'node', 'title', 'description', 'required'],
  name: "demo-node",
  methods: {
    addStep(event){
        this.add(event)
    }
  }
}

</script>

<style lang="scss">

.flowy-drag-handle button {
  cursor: grab;
}

.flowy-block.draggable-mirror {
  opacity: 0.6;
}
  
.indicator-add {
  font-size: 1.3em;
  width: 16px;
  height: 16px;
  border-radius: 10px;
  left: 48.5%;
  bottom: 2px;
  margin-top: -5px;
  margin-left: -6px;
  opacity: 0.6;
  transition: all 0.3s cubic-bezier(0.05, 0.03, 0.35, 1);
  transform: scale(1);
  position: absolute;
  z-index: 2;
  content:'+'
}
</style>